
import { defineComponent, inject } from 'vue'
import TextInput from '@/components/shared/TextInput.vue'
import { PROVIDER_CONSTANTS } from '@/constants/provider.constants'
import { MiscellaneousService } from '@/services/miscellaneous.service'
import { ResetPasswordMessage } from '@/@types/messages/ResetPasswordMessage'
import Toaster from '@meforma/vue-toaster'
import LockingButton from '@/components/shared/LockingButton.vue'
import { ErrorsResponse } from '@/@types/responses/common/ErrorsResponse'

export default defineComponent({
  name: 'ResetPassword',
  components: {
    LockingButton,
    TextInput
  },
  props: {
    id: {
      type: String,
      required: true
    },
    token: {
      type: String,
      required: true
    }
  },
  setup() {
    const miscellaneousService = inject(PROVIDER_CONSTANTS.miscellaneousService) as MiscellaneousService
    const toast = inject(PROVIDER_CONSTANTS.toaster) as Toaster

    return {
      miscellaneousService,
      toast
    }
  },
  data() {
    return {
      password: '',
      loading: false,
      showErrorMessage: false,
      errorMessage: ''
    }
  },
  computed: {
    formValid(): boolean {
      return this.password.trim() !== ''
    }
  },
  methods: {
    onEnterPressed(): void {
      if (this.formValid)
        this.resetPassword()
    },
    resetPassword(): void {
      if (this.loading) return

      this.showErrorMessage = false
      this.loading = true

      const resetPasswordMessage = new ResetPasswordMessage(this.id, this.password, this.token)
      this.miscellaneousService.resetPassword(resetPasswordMessage).then(() => {
        this.loading = false
        this.toast.success('Password reset successfully.')
        this.$router.push('/')
      }).catch(error => {
        const errorsResponse = error as ErrorsResponse

        this.loading = false
        this.errorMessage = errorsResponse.errors.map(e => e.message).join("\r\n")
        this.showErrorMessage = true
      })
    }
  }
})
